import React from "react";
import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { FixtureEventCard } from "./FixtureEventCard";
import { OutrightEventCard } from "./OutrightEventCard";
import { getFunctionHandler } from "../../../../constants";
import { SportsbookContext } from "../../contexts";
export const eventCardMap = new Proxy({
    Fixture: FixtureEventCard,
    Outright: OutrightEventCard
}, getFunctionHandler);
export const EventCard = (props) => {
    const { event } = props;
    const { getNavLink } = React.useContext(SportsbookContext);
    const EventCard = eventCardMap[event.eventType];
    const eventStatus = getTruthyValue(event.status, "");
    const isEventPreLive = ["notstarted", "starting"].includes(eventStatus.toLowerCase());
    const isEventAccessible = event.isLive || isEventPreLive;
    const isOutright = event.eventType === "Outright";
    const EventWithLink = isEventAccessible && !isOutright ? getNavLink({ eventId: event.eventId, eventName: event.eventDisplayName, children: React.createElement(EventCard, Object.assign({}, event)) }) : React.createElement(EventCard, Object.assign({}, event));
    return EventWithLink;
};
//# sourceMappingURL=EventCard.js.map